import { useContext } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { WelletContext } from '../../../context/wellet/welletContext';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { deleteSpecialDate } from '../../../services';
import { Loading, Modal, Toast } from '../../../uiComponents/common';

const DeleteEventModal = ({ eventId, open, setOpen, refetchQuery }) => {
  const methods = useForm();
  const welletContext = useContext(WelletContext);
  const { t } = useTranslation('translation', { keyPrefix: 'modals.deleteEvent' });

  const deleteMutation = useMutation({
    mutationFn: () => {
      return deleteSpecialDate(welletContext, eventId);
    },
    onSuccess: () => {
      refetchQuery();
    },
  });

  const handleClose = () => {
    setOpen('');
    deleteMutation.reset();
  };

  const onSubmit = () => {
    deleteMutation.mutate();
  };

  return (
    <>
      <FormProvider {...methods}>
        <Modal
          textCancel={t('cancel')}
          textSubmit={t('delete')}
          idModal={'deleteEventModal'}
          title={t('title')}
          btnType='submit'
          maxWidth='450px'
          onClose={() => setOpen('')}
          open={open}
          isLoading={deleteMutation.isLoading || deleteMutation.isSuccess}
          handleSubmit={methods.handleSubmit(onSubmit)}
        >
          <div className='text-left mt-2 mb-3'>{t('ask')}</div>
        </Modal>
      </FormProvider>
      {deleteMutation.isError && (
        <Toast message={t('toast.error')} type='ERROR' onCallback={handleClose} />
      )}
      {deleteMutation.isSuccess && (
        <Toast message={t('toast.success')} type='SUCCESS' onCallback={handleClose} />
      )}
    </>
  );
};

export default DeleteEventModal;
